import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccessControlEntry } from '../shared/auth/access-control-entry';
import { AuthGuard } from '../shared/auth/auth-guard.service';
import { SecurityElementNames } from '../shared/auth/constants/security-element-names.service';
import { EComItemSettingsDialogComponent } from './ecom-item-settings-dialog/ecom-item-settings-dialog.component';
import { EComListComponent } from './ecom-list/ecom-list.component';

const securityElementNames = new SecurityElementNames();

const routes: Routes = [
  { path: 'test', component: EComItemSettingsDialogComponent },
  { title: 'ecommerce.ecommerce-list.title', path: 'item-list', component: EComListComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EcomRoutingModule {}
